<template>
  <div>
    <div class="workerList">
      <div class="select">
        <el-row>
          <el-col :span='12'><span class="worker">工作者</span></el-col>
          <el-col :span="12">
            <div class="searchList" >
              <ul>
                <li v-if="listCurrent == 3" @click="cancelStop">取消阻止</li>
                <li v-if="listCurrent == 0" @click="refuseWorker">拒绝工人</li>
                <li v-if="listCurrent == 0" @click="agreenWorker">同意工人</li>
                <li v-if="listCurrent == 1" @click="openStopDialog">阻止工人</li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 搜索栏 -->
      <div class="list">
        <ul>
          <li :class="{'active': listCurrent == 0}" @click="changeUserList(0)">申请中</li>
          <li :class="{'active': listCurrent == 1}" @click="changeUserList(1)">已同意</li>
          <li :class="{'active': listCurrent == 2}" @click="changeUserList(2)">已拒绝</li>
          <li :class="{'active': listCurrent == 3}" @click="changeUserList(3)">已阻止</li>
        </ul>
      </div>

      <!-- 表格 -->
      <el-table ref="workerList"
      :data="workerList"
      class="workerForm"
      v-loading='loading'
      :cell-style="openTableCellStyle"
      :row-style="openTableRowStyle"
      :header-cell-style="openTableHeaderColor"
      @selection-change="handleSelectionChange"
      style="width: 100%">
        <el-table-column v-if="listCurrent != 2" type="selection" width='100'></el-table-column>
        <el-table-column label="#" v-if="listCurrent == 2" type="index" width='100'></el-table-column>
        <el-table-column label="工人名称" prop='userName' align='center' width='200'></el-table-column>
        <el-table-column label="正确率" prop='passingRate' align='center'></el-table-column>
        <el-table-column label="状态" prop='status' align='center'>
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">申请中</span>
            <span v-if="scope.row.status == 1">同意</span>
            <span v-if="scope.row.status == 2">拒绝</span>
            <span v-if="scope.row.status == 3">被阻止</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align='center'>
          <template slot-scope="scope">
            <el-button v-if="listCurrent != 0" type='small' class="check" @click="goMetaData(scope.row.ringUserId,scope.row.userName)">查看详情</el-button>
            <el-button v-else type='small' class="check" @click="openReasonBox(scope.row.applyReason)">申请理由</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination" v-if="workerList.length > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="currentSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total='total'>
        </el-pagination>
      </div>

      <!-- 查看申请理由对话框 -->
      <el-dialog
        title="申请理由"
        :visible.sync="dialogVisible"
        width="40%">
        <div class="checkBox">
          <div>{{ applyReason }}</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 阻止 -->
      <el-dialog
        class="stopDia"
        title="阻止工人"
        :visible.sync="stopDialogVisible"
        width="40%">
        <div>
          <div>请提供理由 :</div>
          <div class="selectDia">
            <el-select v-model="stopForm.value" clearable placeholder="请选择">
              <el-option
                v-for="item in stopOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="area">
            <el-input type='textarea' v-model="stopForm.area" placeholder="请填写详细理由"></el-input>
          </div>
          <div class="select">
            <el-checkbox-group v-model="stopForm.checkboxList">
              <el-checkbox label="1">拒绝工人提交的作业</el-checkbox>
              <el-checkbox label="2">将拒绝通知发布给其他工人</el-checkbox>
              <!-- <el-checkbox label="3">拉入黑名单</el-checkbox> -->
            </el-checkbox-group>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="stopUser()">阻 止</el-button>
          <el-button @click="closeStopDia()">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      workerList: [],
      options: [{ value: '1', label: '弄虚作假'},{ value: '2', label: '滥竽充数'},
                { value: '3', label: '敷衍了事'},{ value: '4', label: '无事生非'},
                { value: '5', label: '其他'}],
      stopOptions: [{ value: '1', label: '弄虚作假'},{ value: '2', label: '滥竽充数'},
                { value: '3', label: '敷衍了事'},{ value: '4', label: '无事生非'},
                { value: '5', label: '其他'}],
      value: 'all',
      currentPage: 1,
      currentSize: 10,
      total: 0,
      status: 1, // 当前状态
      multipleSelection: [], // tab表格选项选中的数组
      listCurrent: 1, // 菜单栏选中项
      projectId: '',
      applyReason: '',
      dialogVisible: false,
      stopDialogVisible: false,
      loading: false,
      stopForm: {
        value: '',
        area: '',
        checkboxList: '',
      },
      idList: [],
      checkList: [],
    }
  },
  created() {
    if (this.$route.query.id) {
      this.projectId = +this.$route.query.id
    } else {
      this.projectId = +this.$store.state.projectId
    }
    this.getWorkerList()
	},
  methods: {

    // 获取员工列表
    getWorkerList () {
      this.loading = true
      this.httpPost('/web/worker/v1/getProjectUserList', {
        pageNum: this.currentPage,
        pageSize: this.currentSize,
        projectId: this.projectId,
        status: this.status
      }).then(res => {
        if (res.code == 0) {
          this.workerList = res.data.data
          this.total = res.data.total
          this.loading = false
        } else if (res.code == 10001 || res.code == 10002) {
          this.loading = false
          this.$message({
            type: 'error',
            message: res.message
          })
        } else {
          this.loading = false
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      })
    },

    // 点击查看详情
    goMetaData (id,name) {
      this.$router.push({
        path: '/data/detail',
        query: {
          ringUserId: id,
          name: name
        }
      })
    },

    // 同意工人申请
    agreenWorker () {
      this.idList = []
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择指定工人'
        })
      } else {
        this.multipleSelection.forEach(item => {
          this.idList.push(item.id)
        })
        this.httpPost('/web/worker/v1/agreeWorkerApply', {
          idList: this.idList,
          projectId: this.projectId,
          cope: 1,
        }).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: res.message
            })
            this.getWorkerList ()
          } else if (res.code == 10001 || res.code == 10002) {
              this.$message({
                type: 'error',
                message: res.message
              })
            } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        })
      }
    },

    // 拒绝工人申请
    refuseWorker () {
      this.idList = []
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择指定工人'
        })
      } else {
        this.multipleSelection.forEach(item => {
          this.idList.push(item.id)
        })
        this.httpPost('/web/worker/v1/refuseWorkerApply', {
          idList: this.idList,
          projectId: this.projectId,
          cope: 2,
        }).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: res.message
            })
            this.getWorkerList ()
          } else if (res.code == 10001 || res.code == 10002) {
              this.$message({
                type: 'error',
                message: res.message
              })
            } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        })
      }
    },

    //打开阻止工人弹框
    openStopDialog(){
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择工人"
        });
      } else {
        this.stopForm = {value: '', area: '', checkboxList:[]}
        this.stopDialogVisible = true;
      }
    },

    //关闭阻止工人弹框
    closeStopDia(){
      this.stopDialogVisible = false;
    },

    //阻止工人
    stopUser(){
      this.idList = []
       if (this.stopForm.value == '') {
        this.$message({
          type: 'warning',
          message: '请提供理由'
        })
      } else if (this.stopForm.select == '') {
        this.$message({
          type: 'warning',
          message: '请选择处理方式'
        })
      } else if (this.stopForm.checkboxList.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择阻止方式'
        })
      } else {
        this.multipleSelection.forEach(item => {
          this.idList.push(item.id)
        })
        var param = {
          "idList": this.idList,
          "checkboxList": this.stopForm.checkboxList,
          "stopNote": this.stopForm.area,
          "stopReason": this.stopForm.value,
          "projectId":this.projectId,
        }
        this.httpPost("/web/worker/v1/stopWorker",param).then(res => {
            if(res.code == 0){
              this.$message({
              type: 'success',
              message: '阻止工人成功'
            })
            this.stopDialogVisible = false
            this.stopForm = {value: '', area: '', checkboxList:[]}
            this.getWorkerList ()
          } else if (res.code == 10001 || res.code == 10002) {
              this.$message({
                type: 'error',
                message: res.message
              })
            } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        })
      }
    },

    //取消阻止工人
    cancelStop(){
      this.idList = [];
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择工人"
        });
        return;
      } else {
        this.multipleSelection.forEach(item => {
          this.idList.push(item.id)
        })
        var param = {
          idList: this.idList
        };
        this.httpPost("/web/worker/v1/cancelStopWorker", param).then(res => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "撤销成功"
            });
            this.getWorkerList ()
          } else if (res.code == 10001 || res.code == 10002) {
              this.$message({
                type: 'error',
                message: res.message
              })
            } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        });
      }
    },

    // 查看申请理由
    openReasonBox (reason) {
      this.dialogVisible = true
      this.applyReason = reason
    },

    // 改变当前页码
    handleSizeChange(val) {
      this.pageSize = val
    },

    // 改变当前每页条数
    handleCurrentChange(val) {
      this.currentPage = val;
    },

    // tab表格多选框选中项
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 改变菜单栏选项
    changeUserList(current) {
      this.listCurrent = current;
      this.status = current
      this.getWorkerList()
    },

     /*修改table tr行的背景色*/
    openTableRowStyle({ row, rowIndex }) {
      return "text-align: center;";
    },
    /*修改table tr行的背景色*/
    openTableCellStyle({ row, rowIndex }) {
      return "height: 30px;text-align: center;";
    },
    /*修改table header的背景色*/
    openTableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7f9;  font-weight: bold;text-align: center;";
      }
    },

  }
}
</script>

<style scoped>
.workerList >>> .el-table th {
  height: 45px;
  color: #777;
  white-space: nowrap;
  overflow: hidden;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #59a7ce42 !important;
}
</style>
<style lang="scss" scoped>
.workerList{
  .explain{
    font-size: 13px;
    margin: 10px 0 30px;
    color: #333;
  }
  .pagination {
    margin-top: 30px;
    float: right;
    margin-bottom: 30px;
  }
  .workerForm{
    margin-top: 10px;
  }
  .select-box{
    float: right;
    width: 150px;
  }
  .select{
    height: 40px;
    line-height: 40px;
    .worker{
      font-weight: bold;
      color: #333;
    }

  }
}
.searchList {
  height: 35px;
  line-height: 35px;
  margin-top: 2px;
  ul {
    li {
      text-align: center;
      border: 1px solid #ccc;
      border-radius: 5px;
      width: 80px;
      float: right;
      margin: 0 0 0 20px;
      cursor: pointer;
      &.active {
        color: #fff;
        background-color: #409eff;
        border: 1px solid #fff;
      }
    }
  }
}
.list {
  width: 100%;
  margin: 20px 0;
  ul {
    overflow: hidden;
    li {
      width: 80px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      border-radius: 5px;
      border: 1px solid #ccc;
      margin-right: 20px;
      float: left;
      cursor: pointer;
      &.active {
        color: #fff;
        background-color: #409eff;
        border: 1px solid #fff;
      }
    }
  }
}
.stopDia{
  .area{
    margin-top: 20px;
  }
  .selectDia{
    margin-top: 20px;
  }
  .select{
    margin-top: 20px;
  }
}
.dia>>>.el-form-item{
  margin-bottom: 18px;
}
.dia>>>.el-dialog__footer {
  padding: 0px 20px 20px;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.statusDia{
  .select-title{
    margin-bottom: 20px;
  }
  .statusDia{
    margin-bottom: 20px;
  }
  .select-list{
    margin-bottom: 20px;
  }
}
.stopDia{
  .area{
    margin-top: 20px;
  }
  .selectDia{
    margin-top: 20px;
  }
  .select{
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/data/workList.vue